import { useEffect } from 'react';
import { TOAST_REGION_SELECTOR } from './types';

/**
 * Keeps the live region exposed while a dialog is open. MUI's `ModalManager`
 * sets `aria-hidden` on every direct child of `document.body` except the modal,
 * and the toast container is one of them. The toast paints above the overlay,
 * so it has to stay in the accessibility tree.
 *
 * The node is queried instead of held in a ref: `DefaultToastContainer` is a
 * plain function component and does not forward one.
 */
export default function useToastContainer(): void {
  useEffect(() => {
    const region = document.querySelector(TOAST_REGION_SELECTOR);

    if (!region) return undefined;

    function exposeRegion(): void {
      if (region.getAttribute('aria-hidden') === 'true') {
        region.removeAttribute('aria-hidden');
      }
    }

    exposeRegion();

    const observer = new MutationObserver(exposeRegion);
    observer.observe(region, { attributeFilter: ['aria-hidden'] });

    return () => observer.disconnect();
  }, []);
}
